import React from 'react';

function UseCases() {
  const useCases = [
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M20 4 L32 10 L32 20 C32 28 20 36 20 36 C20 36 8 28 8 20 L8 10 L20 4Z" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M16 20 L18 22 L24 16" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      title: 'Healthcare & Life Sciences',
      description: 'Automate patient diagnostics, drug discovery, and treatment planning with AI that understands complex medical relationships.',
      metrics: '99.2% diagnostic accuracy'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect x="6" y="10" width="28" height="24" rx="2" stroke="currentColor" strokeWidth="2"/>
          <line x1="6" y1="16" x2="34" y2="16" stroke="currentColor" strokeWidth="2"/>
          <circle cx="12" cy="24" r="2" fill="currentColor"/>
          <circle cx="20" cy="24" r="2" fill="currentColor"/>
          <circle cx="28" cy="24" r="2" fill="currentColor"/>
        </svg>
      ),
      title: 'Financial Services',
      description: 'Real-time fraud detection, risk assessment, and algorithmic trading powered by advanced AI models.',
      metrics: '$2.4B in fraud prevented'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect x="8" y="12" width="24" height="20" rx="2" stroke="currentColor" strokeWidth="2"/>
          <circle cx="20" cy="22" r="6" stroke="currentColor" strokeWidth="2"/>
          <line x1="14" y1="8" x2="14" y2="12" stroke="currentColor" strokeWidth="2"/>
          <line x1="26" y1="8" x2="26" y2="12" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      title: 'Manufacturing',
      description: 'Predictive maintenance, quality control, and supply chain optimization with continuous learning capabilities.',
      metrics: '40% reduction in downtime'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <circle cx="20" cy="20" r="14" stroke="currentColor" strokeWidth="2"/>
          <path d="M20 10 L24 18 L32 18 L26 24 L28 32 L20 28 L12 32 L14 24 L8 18 L16 18 Z" stroke="currentColor" strokeWidth="2" fill="none"/>
        </svg>
      ),
      title: 'Retail & E-commerce',
      description: 'Personalized recommendations, demand forecasting, and dynamic pricing that adapts to market conditions in real-time.',
      metrics: '3.5x increase in conversion'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <circle cx="20" cy="20" r="12" stroke="currentColor" strokeWidth="2"/>
          <circle cx="20" cy="20" r="8" stroke="currentColor" strokeWidth="2"/>
          <circle cx="20" cy="20" r="4" stroke="currentColor" strokeWidth="2"/>
          <line x1="20" y1="8" x2="20" y2="12" stroke="currentColor" strokeWidth="2"/>
          <line x1="20" y1="28" x2="20" y2="32" stroke="currentColor" strokeWidth="2"/>
          <line x1="8" y1="20" x2="12" y2="20" stroke="currentColor" strokeWidth="2"/>
          <line x1="28" y1="20" x2="32" y2="20" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      title: 'Cybersecurity',
      description: 'Threat detection and response with AI models that identify anomalies and predict attacks before they happen.',
      metrics: '10ms threat detection'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect x="8" y="8" width="24" height="24" rx="2" stroke="currentColor" strokeWidth="2"/>
          <path d="M16 14 L24 14" stroke="currentColor" strokeWidth="2"/>
          <path d="M16 20 L24 20" stroke="currentColor" strokeWidth="2"/>
          <path d="M16 26 L20 26" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      title: 'Legal & Compliance',
      description: 'Automated contract analysis, regulatory compliance monitoring, and risk assessment with explainable AI.',
      metrics: '95% compliance accuracy'
    }
  ];

  return (
    <section className="use-cases-section" id="use-cases">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Built for Every Industry</h2>
          <p className="section-subtitle">
            Proven solutions across sectors, delivering measurable results
          </p>
        </div>

        <div className="use-cases-grid">
          {useCases.map((useCase, index) => (
            <div key={index} className="use-case-card">
              <div className="use-case-icon">{useCase.icon}</div>
              <h3 className="use-case-title">{useCase.title}</h3>
              <p className="use-case-description">{useCase.description}</p>
              <div className="use-case-metrics">{useCase.metrics}</div>
              <a href="#" className="use-case-link">
                Learn more →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default UseCases;

